import styled, { createGlobalStyle } from 'styled-components';
import reset from 'styled-reset';
import "../fonts/font.css"
import { Select } from 'antd';

export const GlobalStyle = createGlobalStyle`
${reset}
  * {
    padding: 0;
    margin: 0;
    line-height: 100%;
    list-style: none;
    font-family: 'Suit medium', 'Inter medium';
  }
  
  body{
    padding: 0;
    margin: 0;
    background-color: #F5F4F7;
  }
  
  ::-webkit-scrollbar {
    display: none;
  }
  a {
    color: inherit;
    text-decoration: none;
  }
  input, button {
    background-color: transparent;
    border: none;
    outline: none;
  }
  div, span {
    font-family: 'Suit medium';
  }
  h1, h2, h3, h4, h5, h6{
    font-family:'Suit bold', 'Inter bold';
  }
  ol, ul, li {
    list-style: none;
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  
  .ant-form-item .ant-form-item-explain-error {
    color: rgba(253, 51, 38, 1) !important;
    font-size: 10px;
    font-weight: 400;
    font-family: 'Suit regular';
  }
  
  .ant-modal-close {
    color: rgba(38, 38, 38, 1) !important;
    font-weight: 900 !important;
    font-size: 26px !important;
  }
  .ant-modal-close:hover{
    background-color: transparent !important;
  }
  .ant-select-outlined:not(.ant-select-customize-input) .ant-select-selector {
     border-color:rgba(202, 201, 204, 1) !important;
     border-radius : 4px !important;
  }
  .ant-select-single .ant-select-selector .ant-select-selection-placeholder {
    color: rgba(126, 126, 128, 1) !important;
    font-family: 'Suit regular' !important;
    font-weight: 400;
    font-size: 16px;
    line-height: 22px;
  }
  .ant-select-selection-item {
    font-family: 'Suit regular', 'Inter regular';
    font-weight: 400;
    font-size: 16px;
    color: rgba(38, 38, 38, 1);
  }
  .ant-select-item-option-content {
    font-family: 'Suit regular', 'Inter regular';
    font-weight: 400;
    font-size: 16px;
    color: rgba(38, 38, 38, 1);
  }
  .ant-select-outlined.ant-select-status-error:not(.ant-select-customize-input) .ant-select-selector{
    box-shadow: none !important;
    border-color: rgba(202, 201, 204, 1) !important;
  }
  .ant-select-selection-placeholder {
    color: rgba(126, 126, 128, 1)
  }
`;

export const StyledForm = styled.div`
	display: flex;
	justify-content: space-between;
	width: 100%;
	align-items: center;
	column-gap: 20px;
  @media screen and (min-width: 300px) and (max-width: 1000px) {
    flex-direction: column;
    row-gap: 20px;
    width: 100%;
  }
`

export const FormList = styled.div`
	display: flex;
	flex-direction: column;
	row-gap: 20px;
	width: 100%;
	p {
		color: rgba(253, 51, 38, 1);
		font-size: 12px;
		font-weight: 400;
		font-family: 'Suit regular';
    ${({ theme }) =>
    theme.media.monitor(
      `
				font-size: 18px;
    	`,
    )}
	}
	label {
		color: rgba(38, 38, 38, 1);
		font-size: 18px;
		font-weight: 700;
		line-height: 22px;
		font-family: 'Suit bold';
		margin-right: 10px;
    @media screen and (min-width: 300px) and (max-width: 1000px) {
      font-size: 13px;
      line-height: 20px;
    }
    ${({ theme }) =>
    theme.media.monitor(
      `
				font-size: 20px;
    	`,
    )}
	}
`

export const StyledInput = styled.input`
	width: 100%;
	height: 46px;
	border: solid 1px rgba(202, 201, 204, 1);
	background-color: #FFFFFF;
	border-radius: 4px;
	font-family: 'Suit regular', 'Inter regular';
	font-weight: 400;
	font-size: 16px;
	color: rgba(38, 38, 38, 1);
	text-indent: 15px;
  
  ${({ theme }) =>
    theme.media.monitor(
      `
				height: 55px;
        font-size: 19px;
    	`,
    )}
	
	&::placeholder {
		color: rgba(151, 151, 153, 1);
		opacity: 1;
	}
	
	&:disabled {
		background-color: rgba(250, 249, 252, 1);
		color: rgba(126, 126, 128, 1);
	}
`

export const StyledTextarea  = styled.textarea`
	width: 100%;
	height: 46px;
	border: solid 1px rgba(202, 201, 204, 1);
	background-color: #FFFFFF;
	border-radius: 4px;
	font-family: 'Suit regular', 'Inter regular';
	font-weight: 400;
	font-size: 16px;
	color: rgba(38, 38, 38, 1);
  padding: 15px;
  resize: none;
  &:focus {
        outline: none;
    }
  
  ${({ theme }) =>
    theme.media.monitor(
      `
				height: 55px;
        font-size: 19px;
    	`,
    )}
	
	&::placeholder {
		color: rgba(151, 151, 153, 1);
		opacity: 1;
	}
	
	&:disabled {
		background-color: rgba(250, 249, 252, 1);
		color: rgba(126, 126, 128, 1);
	}
`

export const StyledSelect = styled(Select)`
	width: 100%;
	height: 46px !important;
	background-color: #FFFFFF;
	border-radius: 4px;
	font-family: 'Suit regular', 'Inter regular';
	font-weight: 400;
	font-size: 16px;
	color: rgba(38, 38, 38, 1);

  .ant-select-selector{
    border: solid 1px rgba(202, 201, 204, 1) !important;
    padding: 0 15px !important;
  }
  
  ${({ theme }) =>
    theme.media.monitor(
      `
				height: 55px;
        font-size: 19px;
    	`,
    )}

	
	&:disabled {
		background-color: rgba(250, 249, 252, 1);
		color: rgba(126, 126, 128, 1);
	}
  appearance: none;
  cursor: pointer;
`;

export const ReservationStatus = styled.div<{height: number, status:  "PENDING" | "APPROVED" | "COMPLETED" | "DELETED" | string}>`
	width: 60px;
	height: ${props => `${props.height}px`};
	border: 1px solid ${props => props.status === 'PENDING' ? 'rgba(255, 184, 0, 1)' :  props.status === 'APPROVED'  ? 'rgba(0, 222, 102, 1)' :  props.status === 'COMPLETED' ? 'rgba(0, 87, 255, 1)' : 'rgba(253, 51, 38, 1)'};
	background-color: ${props => props.status === 'PENDING' ? 'rgba(255, 251, 242, 1)' : props.status === 'APPROVED' ? 'rgba(242, 255, 248, 1)' : props.status === 'COMPLETED' ? 'rgba(242, 247, 255, 1)' : 'rgba(253, 241, 240, 1)'};
	color: ${props => props.status === 'PENDING' ? 'rgba(51, 37, 0, 1)' : props.status === 'APPROVED' ? 'rgba(0, 51, 23, 1)' : props.status === 'COMPLETED' ? 'rgba(0, 17, 51, 1)' : 'rgba(51, 10, 8, 1)'};
	font-family: 'Suit regular';
	font-weight: 400;
	font-size: 10px;
	line-height: 22px;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 5px;
  	
	@media screen and (min-width: 300px) and (max-width: 700px) {
    width: 45px;
    font-size: 11px;
    line-height: 28px;
    height: 30px !important;
	}
	@media screen and (min-width: 1920px) and (max-width: 5000px) {
    width: 95px;
    font-size: 16px;
    line-height: 28px;
    height: 40px !important;
	}
`;